(function () {
    "use strict";

    // @ngInject
    function MobileRedirectServiceCtor($window, $state, $stateParams, branch) {
        this.$state = $state;
        this.$window = $window;
        this.$stateParams = $stateParams;
        this.branch = branch;
    }

    Services.MobileRedirectService = Class(function () {


        return {

            constructor: MobileRedirectServiceCtor,

            redirectToBranch: function redirectToBranch(branchOptions, customPayload) {
                var branchData = {
                    '$desktop_url': branchOptions.fallbackLink,
                    '$ios_url': branchOptions.fallbackLink
                };
                var mergedData = angular.extend(branchData,customPayload);
                var that = this;
                this.branch.then(function(branchSdk) {
                    branchSdk.link({
                        tags: [],
                        channel: branchOptions.channel,
                        feature: branchOptions.feature,
                        stage: branchOptions.stage,
                        data: mergedData
                    }, function(err, link) {
                        that.$window.location = link;
                    });
                }.bind(this));
            }
        };
    });
}());
